const firebaseConfig = {

    apiKey: "AIzaSyBpQE7RkelSCCZ29BmGUDLQi4uXPQpslnM",
    authDomain: "dentalcare-b940b.firebaseapp.com",
    projectId: "dentalcare-b940b",
    storageBucket: "dentalcare-b940b.appspot.com",
    messagingSenderId: "1091284859672",
    appId: "1:1091284859672:web:a01b83df2b4641d183fc6d"

}

export default firebaseConfig;